import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import "../pages/PrihvatanjePonude.scss";
import UseTimeout from "../modules/useTimeout";
import React, { useEffect, useState } from "react";

function PrihvatanjePonude() {
  UseTimeout(() => window.location.replace("/logout"), 3000);

  const [cookieData, setCookieData] = useState({});

  useEffect(() => {
    const getCookieData = (ime) => {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split("=");
        if (name === ime) {
          const decodedCookieValue = decodeURIComponent(value);
          return JSON.parse(decodedCookieValue);
        }
      }
      return {};
    };

    const data = getCookieData("pravnoLice");
    setCookieData(data);
  }, []);

  return (
    <main id="prihvatanje-ponude">
      <HeaderComponent id="head-title-ponuda" />
      <Head title="Prihvatanje ponude" />

      {cookieData.logotip && (
        <img
          className="LogotipTitle"
          src={`http://localhost:8080/${cookieData.logotip}`}
          alt="LogotipHeader"
        />
      )}
      <div className="top-left-ponuda">
        Hvala što ste prihvatili našu ponudu!
      </div>
      <div className="top-left-lower-ponuda">
        Kontaktirati ćemo vas što prije!
      </div>
      <div className="top-left-lower-2-ponuda">
        Uskoro ćete biti vraćeni na početnu stranicu.
      </div>
    </main>
  );
}

export default PrihvatanjePonude;
